import {
  useWebAppGetFragmentDetailById,
  webAppGetFragmentDetailByIdQueryKey,
} from '@mi-front/api-v2';

export function useFragmentQuery(fragmentId: string) {
  return useWebAppGetFragmentDetailById(fragmentId, {
    query: {
      refetchInterval: (query) => {
        const data = query.state.data;
        if (!data) {
          return false;
        }

        const isMediaWaiting = data.mediaCompletedAt === null;
        const isTranscriptionWaiting = data.transcriptionCompletedAt === null;

        return isMediaWaiting || isTranscriptionWaiting ? 2000 : false;
      },
    },
  });
}

useFragmentQuery.queryKey = (fragmentId: string) => webAppGetFragmentDetailByIdQueryKey(fragmentId);
